export enum ROUTES_PATH {
  LOGIN = '/login',
  // LOGIN_USERNAME = '/login/username',
  // LOGIN_PASSWORD = '/login/password',
  LOGIN_RESEND_EMAIL = '/login/resend-email',
  // LOGIN_ERROR = '/error',
  LOGIN_CHANGE_PASSWORD = '/change-password',
  LOGIN_RESET_PASSWORD = '/reset-password',
  ONBOARDING = '/onboarding',
  OPERATION_DASHBOARD = '/operation',
  OPERATION_DASHBOARD_DETAIL = '/detail-operation',
  OPERATION_REFUND = '/operation-refund',
  REPORTING = '/reporting',
  MONTH_SETTLEMENT = '/reporting/month-settlements',
  SETTLEMENT_DETAIL = '/reporting/settlement-detail',
  LEARNING = '/learning',
  PLUGIN = '/plugin',
  NOTIFICATIONS = '/notifications',
  PROFILE = '/profile',
  CONTACT = '/contact',
  HELP = '/help',
  FAQ = '/faq',
  SESSION = '/session',
  CONFIGURATION = '/configuration',
  DOCUMENTS = '/documents',
  ALL_RESOURCES_MOBILE = '/all-resources-mobile',
  ARTICLE_DETAIL = '/learning/article',
  ARTICLE_ALL = '/learning/all-articles',
  WEBINAR_DETAIL = '/learning/webinar',
  WEBINAR_ALL = '/learning/all-webinars',
  TERMS_USE = '/terms-of-use',
  PRIVACY_POLICY = '/privacy-policy',
  ACTUALIZA_DATOS_SS = '/actualiza-datos-seguridad-social',
  ALTA_CLAVE_PIN = '/alta-clave-pin',
  LOGIN_SSO = '/login-sso',
}

export const {
  // LOGIN_USERNAME,
  // LOGIN_PASSWORD,
  LOGIN_RESEND_EMAIL,
  // LOGIN_ERROR,
  LOGIN,
  OPERATION_DASHBOARD,
  OPERATION_DASHBOARD_DETAIL,
  OPERATION_REFUND,
  REPORTING,
  LEARNING,
  PLUGIN,
  NOTIFICATIONS,
  PROFILE,
  CONTACT,
  HELP,
  SESSION,
  CONFIGURATION,
} = ROUTES_PATH;

export const dniDatasetExample = {
  type: 'DNI',
  name: 'Carmen',
  last_name: 'Test Test',
  birth_date: '2001-01-01',
  expiration_date: '2030-01-01',
  document_id: '46937002M',
  nationality: 'ES',
  gender: 'M',
  support_number: 'BLV141322',
  face_photo: 'TWFuIGlzIGRpc3Rpbmd1aXNoZWQsIG5vdCBvbmx5IGJ5IGhpcyByZWFzb24sIGJ1dCBieSB0aGlzIHNpbmd1bGFyIHBhc3Npb24gZnJvbSBvdGhlciBhbmltYWxzLCB3aGljaCBpcyBhIGx1c3Qgb2YgdGhlIG1pbmQsIHRoYXQgYnkgYSBwZXJzZXZlcmFuY2Ugb2YgZGVsaWdodCBpbiB0aGUgY29udGludWVkIGFuZCBpbmRlZmF0aWdhYmxlIGdlbmVyYXRpb24gb2Yga25vd2xlZGdlLCBleGNlZWRzIHRoZSBzaG9ydCB2ZWhlbWVuY2Ugb2YgYW55IGNhcm5hbCBwbGVhc3VyZS4=',
  card_access_number: '123456',
  address: 'Calle España nº 1234',
  birth_place: 'Valencia',
  fathers_name: 'Will',
  mothers_name: 'Kate',
  signature_photo: 'TWFuIGlzIGRpc3Rpbmd1aXNoZWQsIG5vdCBvbmx5IGJ5IGhpcyByZWFzb24sIGJ1dCBieSB0aGlzIHNpbmd1bGFyIHBhc3Npb24gZnJvbSBvdGhlciBhbmltYWxzLCB3aGljaCBpcyBhIGx1c3Qgb2YgdGhlIG1pbmQsIHRoYXQgYnkgYSBwZXJzZXZlcmFuY2Ugb2YgZGVsaWdodCBpbiB0aGUgY29udGludWVkIGFuZCBpbmRlZmF0aWdhYmxlIGdlbmVyYXRpb24gb2Yga25vd2xlZGdlLCBleGNlZWRzIHRoZSBzaG9ydCB2ZWhlbWVuY2Ugb2YgYW55IGNhcm5hbCBwbGVhc3VyZS4=',
};

export const fullMonths = [
  'Enero',
  'Febrero',
  'Marzo',
  'Abril',
  'Mayo',
  'Junio',
  'Julio',
  'Agosto',
  'Septiembre',
  'Octubre',
  'Noviembre',
  'Diciembre',
];

export const TABLE_SCROLL_EVENT = 'table-scroll-sync';
export const TABLE_SCROLL_EVENT_BOTTOM = 'table-scroll-sync-bottom';

// CONSTANTES PARA CONTROLAR LAS IMAGENES DEL LOGIN
// En un futuro se planteará gestionar la imagen y el texto desde una plataforma externa
export const BELENDER_EXPIRATION = false;
export const COUNTER_OFFER_EXPIRATION = false;
export const GREEN_CARD_EXPIRATION = true;
